import React from "react";

export class ThanksModel extends React.Component {
  render() {
    return (
      <React.Fragment>
        {this.props.status &&
          <>
            <div className="modal fade in " id="editdata" role="dialog">
              <div className= {this.props.page === "contact" ?  "modal-dialog modal-content-center" :"modal-dialog"} >
                <div className="modal-content">
                  {this.props.header &&
                    <div className="modal-header">
                      <h4 className="modal-title">{this.props.header ? this.props.header : ""}</h4>
                    </div>
                  }
                  <div className="modal-body mod-body">
                    <h5 className="modal-title mod-title epaperroadmodal"     >{this.props.text}</h5>

                  </div>
                  <div className="model-btn text-center mb-3">


                    <button type="button" className="btnDefault" onClick={this.props.confirmOkay}  >Ok</button>


                  </div>

                </div>
              </div>
            </div>
          </>
        }

      </React.Fragment>
    )
  }

}
export default ThanksModel;